// App-wide configuration — single source of truth for env values and defaults

export const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

export const STORAGE_KEYS = {
  auth: 'carbon.auth.v1',
  tweaks: 'carbon.tweaks.v1',
  lang: 'carbon.lang.v1',
  sidebar: 'carbon.sidebar.v1',
};

export const APP_ACCENT = '#059669';
export const APP_ACCENT_DARK_MODE = '#34d399';

export const TWEAK_DEFAULTS = {
  density: 'regular',
  dark: false,
  showHeatmap: true,
};

export const FALLBACK_TZ = 'Asia/Tokyo';
